import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.organizations;
export const organizationsSelector = (state: RootState) => getState(state).data;
export const organizationsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const organizationsIsReadySelector = (state: RootState) => getState(state).isReady;
export const organizationsErrorSelector = (state: RootState) => getState(state).error;
export const organizationByIdSelector = (organizationId?: number) => (state: RootState) =>
  organizationsSelector(state).find(org => org.id === organizationId);
